import React from 'react';

const materialFields = [
    "manufacturer_reference",
    "aisi_sae",
    "din",
    "uns",
    "wnr",
    "afnor",
    "bts",
    "jis",
    "en",
    "uni",
    "sis",
    "astm",
];

const MaterialSummary = ({ rowData }) => {
    return (
        <span style={{ direction: "ltr" }}>
            {
                materialFields.map(field => {
                    return rowData[field] && rowData[field] !== "-" ? field === "wnr" ? `${Number(rowData[field]).toFixed(4)}` : `${rowData[field]}` : "";
                }).filter(m => m !== "").join(" \\ ")
            }
        </span>
    );
}

export default MaterialSummary;
